import { createRouter, createWebHashHistory } from 'vue-router'
import Informations from '../views/Informations.vue'
import WeChatMini from '../views/weChatMini/index.vue'
import Login from '../views/weChatMini/login.vue'
import LoginPhone from '../views/weChatMini/loginPhone.vue'

import WeeklyRecipe from '../views/WeeklyRecipe.vue'
import BusinessReports from '../views/BusinessReports.vue'
import EditStudentsInfo from '../views/weChatMini/editStudentsInfo.vue'

import CollegeStudents from '../views/weChatMini/collegeStudents.vue'
import StudentsInfo from '../views/weChatMini/studentsInfo.vue'
import SignIn from '../views/weChatMini/signIn.vue'
import TravelRecords from '../views/weChatMini/travelRecords.vue'
import MealRecord from '../views/weChatMini/mealRecord.vue'
import SignInRecord from '../views/weChatMini/signInRecord.vue'
import SignAContractRecord from '../views/weChatMini/signAContractRecord.vue'
import MonitorStudents from '../views/weChatMini/monitorStudents.vue'
import ManagementPanel from '../views/weChatMini/managementPanel.vue'
import BedBoard from '@/views/weChatMini/bedBoard.vue'
import CheckinRecords from '@/views/weChatMini/checkinRecords.vue'
import MealReservation from '../views/meal/MealReservation.vue'
import MealReservationForm from '../views/meal/MealReservationForm.vue'
import CustomerMealReservation from '../views/meal/CustomerMealReservation.vue'
import ExclusiveRecipe from '../views/meal/ExclusiveRecipe.vue'
import CustomerOrdering from '../views/meal/CustomerOrdering.vue'
import CustomerMealReservationDetail from '../views/meal/CustomerMealReservationDetail.vue'
import CommunicationRecords from '../views/weChatMini/communicationRecords.vue'
import AddCommunication from '../views/weChatMini/addCommunication.vue'

import ActivityGraphic from '../views/activity/graphic.vue'
import ActivityEat from '../views/activity/eat.vue'
import ActivitySleep from '../views/activity/sleep.vue'
import ActivityStudent from '../views/activity/student.vue'
import ActivityChuang from '../views/activity/chuang.vue'

import PointsExchange from '../views/points/exchange.vue'
import PointsDetails from '../views/points/details.vue'

import Monitor from '../views/monitor.vue'
import MonitorDetail from '../views/monitorDetail.vue'
import Registration from '../views/registration/index.vue'
import HtmlParsing from '../views/registration/htmlParsing.vue'

const routes = [
  {
    path: '/drink-menu',
    name: 'DrinkMenu',
    component: () => import(/* webpackChunkName: "drink-menu" */ '../views/drink/DrinkMenu.vue'),
    meta: { title: '饮品选择' }
  },
  {
    path: '/drink-confirm',
    name: 'DrinkConfirm',
    component: () => import(/* webpackChunkName: "drink-confirm" */ '../views/drink/DrinkConfirm.vue'),
    meta: { title: '确认饮品' }
  },
  {
    path: '/informations',
    component: Informations,
    name: 'Informations',
    meta: { title: '资讯' }
  },
  {
    path: '/weeklyRecipe',
    component: WeeklyRecipe,
    name: 'WeeklyRecipe',
    meta: { title: '每周食谱' }
  },
  {
    path: '/userAgreement',
    component: () => import(/* webpackChunkName: "userAgreement" */ '../views/UserAgreement.vue'),
    name: 'UserAgreement',
    meta: { title: '用户协议' }
  },
  {
    path: '/privacyAgreement',
    component: () => import(/* webpackChunkName: "privacyAgreement" */ '../views/PrivacyAgreement.vue'),
    name: 'PrivacyAgreement',
    meta: { title: '用户协议' }
  },
  {
    path: '/businessReports',
    component: BusinessReports,
    name: 'BusinessReports',
    meta: { title: '营养报告' }
  },
  {
    path: '/weChatMini',
    component: WeChatMini,
    name: 'WeChatMini',
    meta: { title: '优益优加' }
  },
  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta: { title: '优益优加登录' }
  },
  {
    path: '/loginPhone',
    component: LoginPhone,
    name: 'LoginPhone',
    meta: { title: '优益优加登录' }
  },
  {
    path: '/collegeStudents',
    component: CollegeStudents,
    name: 'CollegeStudents',
    meta: { title: '书院学生' }
  },
  {
    path: '/studentsInfo',
    component: StudentsInfo,
    name: 'StudentsInfo',
    meta: { title: '学生详情' }
  },
  {
    path: '/editStudentsInfo',
    component: EditStudentsInfo,
    name: 'EditStudentsInfo',
    meta: { title: '学生详情' }
  },
  
  {
    path: '/signIn',
    component: SignIn,
    name: 'SignIn',
    meta: { title: '签到统计' }
  },
  {
    path: '/travelRecords',
    component: TravelRecords,
    name: 'TravelRecords',
    meta: { title: '进房情况' }
  },
  {
    path: '/mealRecord',
    component: MealRecord,
    name: 'MealRecord',
    meta: { title: '餐食记录' }
  },
  {
    path: '/signInRecord',
    component: SignInRecord,
    name: 'SignInRecord',
    meta: { title: '签到记录' }

  },
  {
    path: '/signAContractRecord',
    component: SignAContractRecord,
    name: 'SignAContractRecord',
    meta: { title: '签约记录' }
  },
  {
    path: '/monitorStudents',
    component: MonitorStudents,
    name: 'MonitorStudents',
    meta: { title: '监控' }
    
  },
  {
    path: '/activity/graphic',
    component: ActivityGraphic,
    name: 'ActivityGraphic',
    meta: { title: '活动详情' }
  },
  {
    path: '/activity/eat',
    component: ActivityEat,
    name: 'ActivityEat',
    meta: { title: '吃' }
  },
  {
    path: '/activity/student',
    component: ActivityStudent,
    name: 'ActivityStudent',
    meta: { title: '学' }
  },
  {
    path: '/activity/sleep',
    component: ActivitySleep,
    name: 'ActivitySleep',
    meta: { title: '睡' }
  },
  {
    path: '/activity/chuang',
    component: ActivityChuang,
    name: 'ActivityChuang',
    meta: { title: '创' }
  },
  {
    path: '/points/exchange',
    component: PointsExchange,
    name: 'PointsExchange',
    meta: { title: '积分' }
  },
  {
    path: '/points/detail',
    component: PointsDetails,
    name: 'PointsDetails',
    meta: { title: '积分明细' }
  },
  {
    path: '/managementPanel',
    component: ManagementPanel,
    name: 'ManagementPanel',
    meta: { title: '经营看板' }
  },
  {
    path: '/bedBoard',
    component: BedBoard,
    name: 'BedBoard',
    meta: { title: '床位看板' }
  },
  {
    path: '/checkinRecords',
    component: CheckinRecords,
    name: 'CheckinRecords',
    meta: { title: '入住记录' }
  },
  {
    path: '/monitor',
    component: Monitor,
    name: 'Monitor',
    meta: { title: '监控' }
  },
  {
    path: '/monitorDetail',
    component: MonitorDetail,
    name: 'MonitorDetail',
    meta: { title: '监控详情' }
  },
  {
    path: '/registration',
    component: Registration,
    name: 'registration',
    meta: { title: '问卷调查' }
  },
  {
    path: '/htmlParsing',
    component: HtmlParsing,
    name: 'htmlParsing',
    meta: { title: '问卷调查' }
    
  },
  {
    path: '/meal/reservation',
    component: MealReservation,
    name: 'MealReservation',
    meta: { title: '预约送餐' }
  },

  {
    path: '/meal/customer-reservation',
    component: CustomerMealReservation,
    name: 'CustomerMealReservation',
    meta: { title: '预约送餐' }
  },
  
  {
    path: '/meal/reserve',
    component: MealReservationForm,
    name: 'MealReservationCreate',
    meta: { title: '新建预约' }
  },
  {
    path: '/meal/edit',
    component: MealReservationForm,
    name: 'MealReservationEdit',
    meta: { title: '编辑预约' }
  },
  {
    path: '/meal/exclusive-recipe',
    component: ExclusiveRecipe,
    name: 'ExclusiveRecipe',
    meta: { title: '专属食谱' }
  },
  {
    path: '/meal/customer-ordering',
    component: CustomerOrdering,
    name: 'CustomerOrdering',
    meta: { title: '点餐' }
  },

  {
    path: '/meal/customer-reservation-detail',
    component: CustomerMealReservationDetail,
    name: 'CustomerMealReservationDetail',
    meta: { title: '订单详情' }
  },

  
  {
    path: '/communicationRecords',
    component: CommunicationRecords,
    name: 'CommunicationRecords',
    meta: { title: '沟通记录' }
  },
  {
    path: '/addCommunication',
    component: AddCommunication,
    name: 'AddCommunication',
    meta: { title: '添加沟通记录' }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
